import { resource } from '@flexteam/static-resource';
import { useQuery } from '@tanstack/react-query';
import { EMOJI_JSON_S3_PATH } from '../constants.mjs';

const queryKey = ["@flexteam/linear-emoji-picker"];
function useEmojis(options) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      const res = await fetch(resource(EMOJI_JSON_S3_PATH));
      const data = await res.json();
      return data;
    },
    cacheTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: false,
    suspense: false,
    useErrorBoundary: false,
    ...options
  });
}

export { useEmojis as default, queryKey };
//# sourceMappingURL=useEmojis.mjs.map
